import { HttpClientModule } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalSearchService } from '../services/globalsearchservice.service';

@Injectable()
export class AuthService {

	public userlogged: boolean;

	constructor(public globalSearchService: GlobalSearchService) {}

	public isAuthenticated(): boolean {

		const user = JSON.parse(localStorage.getItem('user'));
		if(user === null ) {
			return false;
		} else {

			// Self-heal a corrupted location switch: defaultlocation must be an object
			// ({loccode,...}). Older switcher code stored a bare string, which blanks the
			// Warehouse field on order entry (reads defaultlocation.loccode). Restore shape.
			if (user.user && typeof user.user.defaultlocation === 'string') {
				user.user.defaultlocation = { loccode: user.user.defaultlocation };
				localStorage.setItem('user', JSON.stringify(user));
			}

			this.userlogged = true;
			this.globalSearchService.user.next(user);
			this.globalSearchService.applyServerFeatureFlags(user);
			this.globalSearchService.refreshServerFeatureFlags();
			this.globalSearchService.userData.next(user);
			this.globalSearchService.aiDataAvailable$.next(null);

			return true;
		}
	}
}
